// ***************************************
// tgfComponents.ScrollBar
//
// This component displays a progress bar
//
// Copyright 2015 Tingly Games B.V.
// Last Changed: 18-6-2015
// ***************************************
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { tbGame } from "../../engine/tbGame";
import { tgfSettings } from "../tgfSettings";
import { ComponentBase } from "./ComponentBase";
export var ScrollBarDirection;
(function (ScrollBarDirection) {
    ScrollBarDirection[ScrollBarDirection["Vertical"] = 0] = "Vertical";
    ScrollBarDirection[ScrollBarDirection["Horizontal"] = 0] = "Horizontal";
})(ScrollBarDirection || (ScrollBarDirection = {}));
tgfSettings.componentDefaults.scrollBar = {
    imageBack: undefined,
    imageHandle: undefined,
    direction: ScrollBarDirection.Vertical,
    width: undefined,
    height: 200,
    marginLeft: 0,
    marginRight: 0,
    marginTop: 0,
    marginBottom: 0
};
var ComponentScrollBar = /** @class */ (function (_super) {
    __extends(ComponentScrollBar, _super);
    function ComponentScrollBar(properties) {
        var _this = _super.call(this) || this;
        _this.roundPosition = false;
        _this.name = "ScrollBar";
        // Initialize properties
        _this.initialize(tgfSettings.componentDefaults.scrollBar);
        // Set user properties
        if (properties !== undefined) {
            _this.setProperties(properties);
        }
        _this.scrollPosition = 0;
        _this.scrollRange = _this.height;
        _this.touchFinger = -1;
        return _this;
    }
    // ***************************************
    // Methods called when events must be processed
    // ***************************************
    ComponentScrollBar.prototype.handleTouchDown = function (finger, screenX, screenY) {
        var xx = this.screenToComponentX(screenX, screenY);
        var yy = this.screenToComponentY(screenX, screenY);
        var ww = this.getWidth();
        var hh = this.getHeight();
        if (xx > -ww / 2 + this.marginLeft && xx < ww / 2 - this.marginRight && yy > -hh / 2 + this.marginTop && yy < hh / 2 - this.marginBottom) {
            this.touchFinger = finger;
            this._updateScrollPosition(xx, yy);
        }
    };
    ComponentScrollBar.prototype.handleTouchUp = function (finger, screenX, screenY) {
        if (this.touchFinger === finger) {
            this.touchFinger = -1;
            this.touchScrollPosition = undefined;
        }
    };
    ComponentScrollBar.prototype.handleEndStep = function (timePassed) {
        if (this.touchFinger !== -1) {
            var touchX = tbGame.touchX(this.touchFinger);
            var touchY = tbGame.touchY(this.touchFinger);
            var xx = this.screenToComponentX(touchX, touchY);
            var yy = this.screenToComponentY(touchX, touchY);
            this._updateScrollPosition(xx, yy);
        }
    };
    ComponentScrollBar.prototype._updateScrollPosition = function (touchX, touchY) {
        var ww = this.getWidth() - this.marginLeft - this.marginRight;
        var hh = this.getHeight() - this.marginTop - this.marginBottom;
        var xx = touchX - this.marginLeft;
        var yy = touchY - this.marginTop;
        var barLength;
        var minHandleLength;
        if (this.direction === ScrollBarDirection.Vertical) {
            barLength = hh;
            minHandleLength = Math.ceil(this.imageHandle.height / 3 * 2);
        }
        else {
            barLength = ww;
            minHandleLength = Math.ceil(this.imageHandle.width / 3 * 2);
        }
        var handleLength = Math.min(barLength, Math.max(minHandleLength, (barLength / this.scrollRange) * barLength));
        if (isNaN(handleLength)) {
            handleLength = barLength;
        }
        var handlePosition;
        if (this.direction === ScrollBarDirection.Vertical) {
            handlePosition = ((yy + hh / 2));
        }
        else {
            handlePosition = ((xx + ww / 2));
        }
        if (isNaN(handlePosition)) {
            handlePosition = 0;
        }
        this.scrollPosition = Math.min(this.scrollRange, Math.max(0, (handlePosition - handleLength / 2) / (barLength - handleLength) * this.scrollRange));
        if (isNaN(this.scrollPosition)) {
            this.scrollPosition = 0;
        }
        this.touchScrollPosition = this.scrollPosition;
    };
    ComponentScrollBar.prototype.getWidth = function () {
        return this.width > 0 ? this.width : (this.imageBack.width + this.marginLeft + this.marginRight);
    };
    ComponentScrollBar.prototype.getHeight = function () {
        return this.height > 0 ? this.height : (this.imageBack.height + this.marginTop + this.marginBottom);
    };
    // Called when the component must be drawn (relative to position 0, 0)
    ComponentScrollBar.prototype.doDraw = function () {
        var ww = this.width > 0 ? (this.width - this.marginLeft - this.marginRight) : this.imageBack.width;
        var hh = this.height > 0 ? (this.height - this.marginTop - this.marginBottom) : this.imageBack.height;
        var xx = -(ww + this.marginLeft + this.marginRight) / 2;
        var yy = -(hh + this.marginTop + this.marginBottom) / 2;
        xx += this.marginLeft;
        yy += this.marginTop;
        if (this.roundPosition) {
            xx = Math.floor(xx);
            yy = Math.floor(yy);
        }
        // Draw the images
        var xf = xx;
        var yf = yy;
        var wf = ww;
        var hf = hh;
        var barLength;
        var minHandleLength;
        if (this.direction === ScrollBarDirection.Vertical) {
            barLength = hh;
            minHandleLength = Math.ceil(this.imageHandle.height / 3 * 2);
        }
        else {
            barLength = ww;
            minHandleLength = Math.ceil(this.imageHandle.width / 3 * 2);
        }
        var handleLength = Math.min(barLength, Math.max(minHandleLength, (barLength / this.scrollRange) * barLength));
        if (isNaN(handleLength)) {
            handleLength = barLength;
        }
        var handlePosition = (barLength - handleLength) * (this.scrollPosition / this.scrollRange);
        if (isNaN(handlePosition)) {
            handlePosition = 0;
        }
        switch (this.direction) {
            case ScrollBarDirection.Vertical:
                yf += handlePosition;
                hf = handleLength;
                break;
            case ScrollBarDirection.Horizontal:
                xf += handlePosition;
                wf = handleLength;
                break;
        }
    };
    return ComponentScrollBar;
}(ComponentBase));
export { ComponentScrollBar };
